import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQuery } from '@tanstack/react-query';

import type { ExtranetBill } from 'app/typings/core/extranet/bills/bill';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export type BillsFilters = {
  sortingColumn?: string;
  sortingOrder?: string;
  offset?: number;
  limit?: number;
};

export function useBills(hotelId: number, queryParams: BillsFilters = {}) {
  return useQuery({
    queryKey: [CORE_QUERY_KEYS.bills, hotelId, queryParams],
    queryFn: () =>
      apiRequest({
        path: ENDPOINTS.getBills,
        params: { hotelId: hotelId.toString() },
        queryParams,
      }) as Promise<ExtranetBill[]>,
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
    enabled: !!hotelId,
    keepPreviousData: true,
  });
}
